import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './Header.css';
import AutoSearch from '../AutoSearch/AutoSearch';
import NavLinks from '../NavLinks/NavLinks';
import MenuIcon from '../MenuIcon/MenuIcon';
import MiniSlider from '../WaterSliderMini/WaterSliderMini';
import withStyles from '../../decorators/withStyles';


class Header extends Component {

  static propTypes = {
    mobileMenuOpen: PropTypes.bool.isRequired,
    modalVisible: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    searchable: false,
  };

  render() {
    var rightColumns = this.props.children ? "six" : "eight";
    return (
      <div className="rising-seas">
        <nav className={"Header row nav " + (this.props.mobileMenuOpen ? "menu-open" : "")}>
          <MenuIcon menuOpen={this.props.mobileMenuOpen} modalVisible={this.props.modalVisible}/>

            <div className="columns four align-left">
              <h1>
                <div className="logo-container">
                  <a className="logo-link--main" href="/">
                    <img className="logo-svg" src={require("../../public/logo-surging-seas-blue.svg")}/>
                  </a>
                  <a className="logo-link--sec" href="/">
                    <span>Risk Finder</span>
                  </a>
                </div>
              </h1>
            </div>

            <div className={"columns " + rightColumns + " align-right"}>
              <NavLinks />
              {(this.props.searchable) ? <AutoSearch /> : <div></div>}
            </div>

          <div className="small-screen columns twelve align-center">
            <MiniSlider horizontal={true} header={true} />
          </div>
        </nav>
      </div>
    );
  }

}

export default withStyles(styles)(Header);
